/* eslint-disable prefer-const */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';
import { PDFGenerator } from '@ionic-native/pdf-generator/ngx';
import { InvoicePage } from '../invoice/invoice.page';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-order-placed-detail',
  templateUrl: './order-placed-detail.page.html',
  styleUrls: ['./order-placed-detail.page.scss'],
})
export class OrderPlacedDetailPage implements OnInit {
  @ViewChild('iframeElement') iframeRef!: ElementRef;

  @Input() data: any;
  o_id: any;
  tot: any;
  res_name: any;
  orders = [];
  schedule_time: any;
  instructions: any;
  time: any;
  total_price_with_extras: number;
  total_price: number;
  userChoices: any = []
  categories: any;
  category: any;
  object: any;
  payment_type: any;
  imageConvert = ''
  node: HTMLElement;
  content: string;
  doordash_data: any;
  invoiceLink: any;
  constructor(public globals: GlobalVariable,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public server: UserApiService,
    public navCtrl: NavController,
    private modalController: ModalController,
    private pdfGenerator: PDFGenerator,
    private iab: InAppBrowser,
    private render: Renderer2
  ) {

   }

  ngOnInit() {
    console.log('orderid', this.data);
  }
  ionViewWillEnter() {
    this.orders = this.data.data
    this.time = this.data.time
    this.instructions = this.data.instructions
    this.schedule_time = this.data.schedule_time
    this.res_name = this.data.res
    this.tot = this.data.tot
    this.o_id = this.data.o_id
    this.payment_type = this.data.p_type
    this.doordash_data = this.data.doordash_data;
    this.node = document.getElementById('print');
    this.invoiceLink = `https://dev.mknxapi.com/api/index.php/business_controller/order_pdf/${this.o_id}`;
    this.loadIframeUrl(this.invoiceLink)
  
  }
  loadIframeUrl(url: string) {
    this.globals.loader()
    const iframe = this.iframeRef.nativeElement;
    iframe.src = url;
    this.render.listen(iframe, 'load', () => {
      this.onIframeLoad();
    });

  }
  onIframeLoad() {
    this.globals.dismiss()
    
  }
  close() {
    this.modalController.dismiss()
  }
  trackOrder(url) {
    const browser = this.iab.create(url, '_system');
  }

  downloadInvoice() {
    this.content = document.getElementById('print').innerHTML;
    let options = {
      documentSize: 'A4',
      type: 'share',
      fileName: 'Order-Invoice.pdf'
    };
    this.pdfGenerator.fromData(this.content, options)
      .then((base64) => {
      }).catch((error) => {
      });

  }
  async invoiceModel() {
    const modal = await this.modalController.create({
      component: InvoicePage,
      componentProps: { orderData: this.data }
    })
    modal.present();
  }
}
